module.exports = __webpack_public_path__ + "img/shangpu.27db44db.png";